import Logo2 from "./../../assets/Logo2.png";
import Logo1 from "./../../assets/Logo.png";
import Button from "../../components/Buttons/Button";
import React, {
  FormEvent,
  useCallback,
  useRef,
  useState,
  useEffect,
} from "react";
import { secondary } from "../../theme";
import { useApi } from "../../hooks/api";
import { useForm } from "react-hook-form";
import { useGlobal } from "../../hooks/global";
import { IGroupProps } from "../../interfaces";
import { validateEmail } from "../../utils/validatesFields";
import { ModalLoading } from "../../components/Loadings/ModalLoading";
import {
  GenericForm,
  IGenericFormRefProps,
} from "../../components/GenericForm";
import {
  Container,
  ContainerBottomButtons,
  ContainerTop,
  Description,
  Form,
  Title,
  LogoImg,
  Content,
  ContainerTerms,
  AnchorTerms,
  Span,
} from "./style";
import { useSearchParams } from "react-router-dom";

const terms_url =
  "https://ilumeo-brasil-com-br.s3.sa-east-1.amazonaws.com/termos-e-condicoes-de-uso-inside+brasil.pdf";

interface INewAccountProps { }

const type: number = 2;

const getDeviceType = () => {
  const isMobile =
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone|iPad|iPod/i);
  if (!isMobile) return "web";
  else if (navigator.userAgent.match(/Android/i)) return "android";
  else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) return "ios";
  else return "web";
};

export const NewAccount: React.FC<INewAccountProps> = () => {
  const [params] = useSearchParams();

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
  } = useForm({
    mode: "onChange",
  });

  const _form = watch();

  const form_ref = useRef<IGenericFormRefProps>(null);
  const buttonSubmitRef = useRef<HTMLButtonElement>(null);

  const { notify } = useGlobal();
  const { api } = useApi();

  const incrementCampaignClicks = useCallback(async () => {
    console.log("Incrementing campaign clicks...");
    const recommendation_code = params.get("code");
    const tracking_code = params.get("tracking_code");

    console.log(
      `Tracking campaign click with recommendation_code: ${recommendation_code}, tracking_code: ${tracking_code}`
    );

    if (recommendation_code && tracking_code) {

      try {
        await api.post("/acquisition-campaign-shots/increment-clicks", {
          recommendation_code,
          tracking_code,
        });
        console.log("Campaign click tracked successfully");
      } catch (error) {
        console.error("Error tracking campaign click:", error);
      }
    }
  }, [api, params]);

  useEffect(() => {
    incrementCampaignClicks();
  }, [incrementCampaignClicks]);

  const onSubmit = useCallback(
    async (event) => {
      setLoading(true);

      const form = form_ref.current?.getForm();

      try {
        form.password = form.password.trim();
        form.confirmPassword = form.confirmPassword.trim();

        await api.post("/user", {
          accept_policy_term: true,
          email: form.email,
          email_confirmation: form.confirmEmail,
          password: form.password,
          password_confirmation: form.confirmPassword,
          entry_type: "mobile",
          origin: params.get("origin") ?? "",
          code: params.get("code") ?? "",
          campaign: params.get("campaign") ?? null
        });

        const deviceType = getDeviceType();
        if (deviceType === "web")
          window.location.href =
            "https://play.google.com/store/apps/details?id=br.com.inside.mobileApp";
        else if (deviceType === "android")
          window.location.href =
            "https://play.google.com/store/apps/details?id=br.com.inside.mobileApp";
        else if (deviceType === "ios")
          window.location.href =
            "https://apps.apple.com/br/app/inside-brasil/id6737057631";
        else
          window.location.href =
            "https://play.google.com/store/apps/details?id=br.com.inside.mobileApp";
      } catch (err: any) {
        const error = err.response?.data?.message
          ? err.response?.data?.message
          : "SERVER ERROR";
        if (error === "User already exists!")
          setError("email", { type: "manual", message: "Email já cadastrado" });
        else
          notify(
            "Erro ao tentar realizar cadastro, tente novamente mais tarde",
            "error"
          );
      }

      setLoading(false);
    },
    [form_ref, api, _form]
  );

  const handleStopPropagation = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e?.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    [handleSubmit, onSubmit, form_ref, _form, api]
  );

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "email",
            label: "Email",
            type: "input",
            validate: validateEmail,
            required: true,
            noUpperCase: true,
          },
        ],
        [
          {
            name: "confirmEmail",
            label: "Confirme seu email",
            type: "input",
            required: true,
            noUpperCase: true,
            validate: async (value: any) => {
              const email = watch("email");
              if (value !== email) return "Os emails não conferem.";
              return true;
            },
          },
        ],
        [
          {
            name: "password",
            label: "Senha",
            type: "input",
            required: true,
            isPassword: true,
            noUpperCase: true,
          },
        ],
        [
          {
            name: "confirmPassword",
            label: "Confirme sua senha",
            type: "input",
            required: true,
            isPassword: true,
            validate: async (value: any) => {
              const password = watch("password");
              if (value !== password) return "As senhas não conferem.";
              return true;
            },
            noUpperCase: true,
          },
        ],
      ],
    },
  ];

  return (
    <Container>
      <Content type={type}>
        <ContainerTop>
          <LogoImg src={type === 1 ? Logo1 : Logo2} height={120} />

          <Title>💸 Aqui sua opinião tem valor!</Title>

          <Description>
            Faça seu cadastro e comece a ganhar dinheiro com a Inside Brasil
          </Description>
        </ContainerTop>

        <Form onSubmit={handleStopPropagation}>
          <GenericForm
            ref={form_ref}
            groups={groups}
            _form={_form}
            control={control}
            trigger={trigger}
            errors={errors}
            setValue={setValue}
            register={register}
            noTrigger
          />

          <button
            ref={buttonSubmitRef}
            type="submit"
            style={{ display: "none" }}
          />
        </Form>

        <ContainerBottomButtons>
          <Button
            color="#FFF"
            background={secondary.light}
            onClick={() => buttonSubmitRef.current?.click()}
            style={{ fontSize: 15, padding: "8px 16px" }}
            children="Criar conta"
            disabled={loading}
          />

          <ContainerTerms>
            Ao criar sua conta, você concorda com os
            <AnchorTerms
              target="_blank"
              href={terms_url}
              children={<Span> termos de uso</Span>}
            />
            .
          </ContainerTerms>
        </ContainerBottomButtons>
      </Content>

      <ModalLoading loading={loading} theme="light" />
    </Container>
  );
};
